import { render, staticRenderFns } from "./shr.vue?vue&type=template&id=1bbb9cc2&scoped=true&"
import script from "./shr.vue?vue&type=script&lang=js&"
export * from "./shr.vue?vue&type=script&lang=js&"
import style0 from "./shr.vue?vue&type=style&index=0&id=1bbb9cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb9cc2",
  null
  
)

export default component.exports